import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Learnspace, LearnspaceUserRole, ListQueryOptions } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CurrentHubService } from '@shared/services/currentHub.service';

@Component({
  selector: 'hub-practise-list',
  templateUrl: './hub-practise-list.component.html',
  styleUrls: ['./hub-practise-list.component.scss']
})
export class HubPractiseListComponent implements OnInit {
  @Input() title!: string;
  @Output() cardClicked = new EventEmitter<Learnspace>();
  @Output() viewAllClicked = new EventEmitter<void>();

  learnspaces: Learnspace[] = [];
  isLoading = true;
  skeletonItems: unknown[] = [];
  listSize = 5;

  constructor(
    private _courseApiService: CoursesAPIService,
    private _currentHub: CurrentHubService
  ) {}

  ngOnInit(): void {
    this._currentHub.hubObservable.subscribe(async (hub) => {
      if (hub) {
        this.isLoading = true;
        this.skeletonItems = Array(this.listSize);
        this.learnspaces = await this.loadLearnspaces(hub.id);
        this.isLoading = false;
      }
    });
  }

  getParticipantCount(ls: Learnspace): number | undefined {
    return ls.participantCount ? +ls.participantCount : undefined;
  }

  private async loadLearnspaces(hubId: string): Promise<Learnspace[]> {
    try {
      const options = new ListQueryOptions('status,-updatedAt', '', 0, this.listSize, true, LearnspaceUserRole.learner);
      const result = await this._courseApiService.getLearnspacesJoinedByHub(hubId, options).toPromise();
      return result.learnspaces;
    } catch {
      return [];
    }
  }
}
